import { useMutation, useQueryCache } from "react-query";
import useNetworkHeaders from "../../../../hooks/useNetworkHeaders";
import { postInspectionItemComment } from "../../api/inspections/postInspectionItemComment";
import { getInspectionItemCommentQueryKey } from "./useInspectionItemComments";

export default function useCreateInspectionCommentMutation() {
  const headers = useNetworkHeaders();
  const queryCache = useQueryCache();

  const [createInspectionItemCommentMutation, createInspectionItemCommentState] = useMutation(
    postInspectionItemComment(headers),
  );

  const handleCreateInspectionItemComment = (
    inspectionId: string | number,
    sectionId: string | number,
    itemId: string | number,
    comment: string,
    attachments: string[],
  ) => {
    createInspectionItemCommentMutation(
      {
        id: Number(inspectionId),
        sectionId: Number(sectionId),
        itemId: Number(itemId),
        comment: comment,
        attachments: attachments,
      },
      {
        onSuccess: () => {
          const inspectionItemCommentsQueryKey = getInspectionItemCommentQueryKey(inspectionId, sectionId, itemId);
          queryCache.invalidateQueries(inspectionItemCommentsQueryKey);
        },
      },
    );
  };

  return {
    createInspectionItemComment: handleCreateInspectionItemComment,
    isLoading: createInspectionItemCommentState.isLoading,
  };
}
